import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles((theme) => ({
  header: {
    display: 'flex',
    backgroundColor: theme.utils.rgba(theme.palette.primary.main, 0.8),

    '&.alt': {
      backgroundColor: '#000051'
    }
  },
  featureImageContainerMobile: {
    maxHeight: 620,
    height: '48vw',
    display: 'flex',
    [theme.breakpoints.up('lg')]: {
      display: 'none'
    }
  },
  featureImageContainer: {
    display: 'none',
    [theme.breakpoints.up('lg')]: {
      display: 'flex',
      minWidth: 827,
      width: '60%',
      height: '29vw',
      maxHeight: 537,
      minHeight: 403,
      flexShrink: 0,
      maxWidth: 1102
    }
  },
  imageInfoContainer: {
    backgroundColor: theme.utils.rgba('#D9D9D9B2', 0.8),
    position: 'absolute',
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: theme.spacing(2),
    [theme.breakpoints.up('sm')]: {
      paddingTop: theme.spacing(4)
    },
    [theme.breakpoints.up('lg')]: {
      padding: 0,
      paddingTop: theme.spacing(6)
    }
  },
  infoContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: 0,
    [theme.breakpoints.up('lg')]: {
      gap: '.7vw'
    }
  },
  infoTitle: {
    fontWeight: 600,
    fontSize: '3.15vw',
    marginBottom: 6,
    [theme.breakpoints.up('lg')]: {
      fontSize: '1.3vw',
      marginBottom: 0
    }
  },
  infoText: {
    fontWeight: 600,
    width: '80%',
    fontSize: '2.89vw',

    [theme.breakpoints.up('lg')]: {
      fontSize: '1.1vw',
      width: '100%'
    }
  },
  endText: {
    marginTop: 6
  },
  featureImage: {
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
    transition: 'opacity ease-in-out 400ms',
    backgroundSize: 'cover',
    height: '100%',
    width: '100%'
  },
  panel: {
    color: theme.palette.primary.contrastText,
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    [theme.breakpoints.up('lg')]: {
      justifyContent: 'space-between'
    }
  },
  titleContainer: {
    flexGrow: 1,
    display: 'flex',
    width: '100%',
    flexDirection: 'column',
    padding: theme.spacing(3, 2),
    justifyContent: 'center',
    [theme.breakpoints.up('lg')]: {
      justifyContent: 'center',
      alignItems: 'flex-start',
      gap: theme.spacing(3),
      padding: theme.spacing(0, 6)
    }
  },
  title: {
    color: theme.palette.primary.contrastText,
    fontWeight: 500,
    fontSize: '1rem',
    textAlign: 'center',

    [theme.breakpoints.up('lg')]: {
      fontSize: '1.3rem',
      textAlign: 'left'
    }
  },
  eventName: {
    marginBottom: theme.spacing(2)
    // [theme.breakpoints.up('lg')]: {
    //   marginBottom: 0
    // }
  },
  actionButton: {
    border: 'none',
    borderRadius: '50%',
    padding: theme.spacing(),
    '&:hover': {
      border: 'none'
    },
    '&:disabled': {
      border: 'none',
      color: theme.palette.primary.main
    },
    [theme.breakpoints.up('lg')]: {
      width: 'auto'
    }
  },
  actionButtonLabel: {
    display: 'flex',
    color: theme.palette.primary.contrastText,
    '& em': {
      fontSize: '1.25em',
      fontStyle: 'normal',
      marginLeft: theme.spacing(1)
    },

    [theme.breakpoints.up('lg')]: {
      flexDirection: 'row',
      '& span': {
        marginLeft: theme.spacing(1)
      }
    }
  },
  eventInfoContainer: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
    display: 'flex',
    flexDirection: 'column',

    [theme.breakpoints.up('lg')]: {
      justifyContent: 'space-between',
      flexDirection: 'row',
      alignItems: 'center',
      background: 'transparent'
    }
  },
  date: {
    fontWeight: 500,
    fontSize: '1.2rem',
    padding: theme.spacing(2),
    flexShrink: 0,
    textTransform: 'uppercase',
    [theme.breakpoints.up('md')]: {
      padding: theme.spacing(4, 6)
    }
  },
  shareButton: {
    color: theme.palette.primary.contrastText,
    borderRadius: '50%',
    padding: theme.spacing()
  },
  kayak: {
    '&.size-2': {
      backgroundPositionX: '38%'
    },
    '&.size-3': {
      backgroundPositionX: '30%'
    }
  },
  running: {
    '&.size-2': {
      backgroundPositionX: '27%'
    },
    '&.size-3': {
      backgroundPositionX: '32%'
    }
  },
  mountainBike: {
    '&.size-2': {
      backgroundPositionX: '46%'
    },
    '&.size-3': {
      backgroundPositionX: '60%'
    }
  },
  natacion: {
    '&.size-2': {
      backgroundPositionX: '55%'
    },
    '&.size-3': {
      backgroundPositionX: '70%'
    }
  },
  biking: {
    '&.size-2': {
      backgroundPositionX: '1%'
    },
    '&.size-3': {
      backgroundPositionX: '15%'
    }
  },
  fbi: {
    '&.size-2': {
      backgroundPositionX: '52%'
    }
  },
  automovilismo: {
    '&.size-2': {
      backgroundPositionX: '42%'
    },
    '&.size-3': {
      backgroundPositionX: '26%'
    }
  },
  motocross: {
    '&.size-2': {
      backgroundPositionX: '97%'
    },
    '&.size-3': {
      backgroundPositionX: '91%'
    }
  },
  trekking: {
    '&.size-2': {
      backgroundPositionX: '29%'
    },
    '&.size-3': {
      backgroundPositionX: '26%'
    }
  },
  ocr: {
    '&.size-3': {
      backgroundPositionX: '60%'
    }
  }
}))
